import React from "react";

export const ButtonLogin = ({ }) => {
    return (
        <button type="submit" className="btn btn-outline-light" id="ButtonLogin">Iniciar sesión</button>
    );
}